import { required, shape, items, concatFailure, unique, logTo } from '@totalsoft/pure-validations';

export const approvalTypeValidator =
  shape({
    approvalTypeCode: required,
    approvalTypeName: required
  }) |> logTo(console);

export const approvalTypeLevelValidator =
  shape({
    header: shape({ levelName: required }),
    approvalTypeEmployees: concatFailure(
      unique(x => x.employeeId || {}, 'ApprovalTypes.ApprovalTypeLevelEmployee.Validators.EmployeeUnique'),
      items(
        shape({
          employeeId: required
        })
      )
    ),
    approvalTypeUserGroups: concatFailure(
      unique(x => x.userGroupId || {}, 'ApprovalTypes.ApprovalTypeLevelUserGroup.Validators.UserGroupUnique'),
      items(
        shape({
          userGroupId: required
        })
      )
    )
  }) |> logTo(console);
